<div class="calsoft-horizontal-navigation-wrapper">

    <ng-container *ngFor="let item of navigation">
        <!-- Skip the hidden items -->
        <ng-container *ngIf="(item.hidden && !item.hidden(item)) || !item.hidden">

            <!-- Basic -->
            <calsoft-horizontal-navigation-basic-item class="calsoft-horizontal-navigation-menu-item"
                                                  *ngIf="item.type === 'basic'"
                                                  [item]="item"
                                                  [name]="name"></calsoft-horizontal-navigation-basic-item>

            <!-- Branch: aside, collapsable, group -->
            <calsoft-horizontal-navigation-branch-item class="calsoft-horizontal-navigation-menu-item"
                                                   *ngIf="item.type === 'aside' || item.type === 'collapsable' || item.type === 'group'"
                                                   [item]="item"
                                                   [name]="name"></calsoft-horizontal-navigation-branch-item>

            <!-- Spacer -->
            <calsoft-horizontal-navigation-spacer-item class="calsoft-horizontal-navigation-menu-item"
                                                   *ngIf="item.type === 'spacer'"
                                                   [item]="item"
                                                   [name]="name"></calsoft-horizontal-navigation-spacer-item>

        </ng-container>

    </ng-container>

</div>
